export type EnneagramQuestion = {
  question: string
}

export const questions: EnneagramQuestion[] = [
  { question: 'I am a perfectionist.' },
  { question: 'My relationships with others are what my life is about.' },
  { question: 'I put work first.' },
  { question: 'I daydream about being in love.' },
  { question: 'I have a hard time showing emotions.' },
  {
    question:
      'Fear of being taken advantage of keeps me from being more trusting.',
  },
  { question: 'I must always be having new experiences.' },
  { question: 'I naturally emerge as a leader.' },
  { question: 'When other people are arguing, I leave the room.' },
  { question: 'I strive for efficiency.' },
  { question: 'I have difficulty saying no.' },
  { question: 'I like to stand out.' },
  { question: 'I really enjoy feeling bitter sweet.' },
  { question: 'I spend hours alone with my hobbies.' },
  { question: 'I get input from others before I make a decision.' },
  { question: 'I can keep a conversation going with anyone about anything.' },
  { question: 'I like a conversation where no one agrees.' },
  { question: 'I keep my thoughts to myself, to prevent trouble.' },
  { question: 'I often have to redo other peoples work.' },
  {
    question:
      'I get lots of satisfaction from helping others achieve their goals.',
  },
  { question: 'It is good to wake up to a full day of planned activities.' },
  { question: 'I cry.' },
  { question: 'I spend most of my time trying to understand things.' },
  { question: 'I conform.' },
  { question: 'I am uninhibited.' },
  { question: 'I want people to tell me the truth, not spare my feelings.' },
  { question: 'I am very accepting and flexible.' },
  { question: 'I keep my belongings in order.' },
  { question: 'I put family first.' },
  { question: 'Money is important to my happiness.' },
  { question: 'I side with the rebels over the establishment.' },
  { question: 'I like mental challenges.' },
  { question: 'I am loyal.' },
  { question: 'I always try to break the tension with a good joke.' },
  { question: 'I prefer it when leaders are decisive.' },
  { question: 'I avoid confrontation.' },
]
